import type { VoidFunctionComponent } from 'react';

import { Status } from '../../../../../../../shared/dependenciesV2';
import { icons, Menu } from '../../../../../generic';
import Button from '../../../../../generic/Button';
import type { Dependency } from '../../../../../../../shared/dependenciesV2';
import type { DependencyV2Modals } from '../../../hooks/useDependencyModals';

import { AnalyzedMenu, BuildDropdown, ErrorDropdown } from './ActionMenus';

import styles from '../DependencyRow.module.less';

type Props = {
  dependency: Dependency;
  status: Status;
  modals: DependencyV2Modals;
  isProjectScope: boolean;
};

export type MenuProps = Omit<Props, 'status'>;

const DependencyActionDropdown: VoidFunctionComponent<Props> = ({ dependency, status, modals, isProjectScope }) => {
  return (
    <div className={styles.DependencyRowDropdown}>
      <Menu
        gap={4}
        direction="left"
        position="initial"
        menuButton={(
          <Button type="outline" icon={icons.ellipsisHorizontal} onClick={() => {}} />
        )}
      >
        {status === Status.Analyzed && (
          <AnalyzedMenu modals={modals} dependency={dependency} isProjectScope={isProjectScope} />
        )}
        {(status === Status.Failed || status === Status.Unknown) && (
          <ErrorDropdown modals={modals} dependency={dependency} isProjectScope={isProjectScope} />
        )}
        {status === Status.InProgress && (
          <BuildDropdown modals={modals} dependency={dependency} isProjectScope={isProjectScope} />
        )}
      </Menu>
    </div>
  );
};

export default DependencyActionDropdown;
